// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TChatsCustomActionRequest,
  TChatsCustomActionModel,
  IMappers,
  TChatsCustomActionResponse,
  TChatsCustomActionResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createChatsCustomActionModel(parameters: TChatsCustomActionRequest): TChatsCustomActionModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/chats/custom-action/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IChatsCustomActionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TChatsCustomActionRequest;
}

export async function fetchChatsCustomAction<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsCustomActionOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatsCustomActionResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatsCustomActionModel(parameters),
    config,
  )) as FetchResponse<TChatsCustomActionResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TChatsCustomActionResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatsCustomActionResponse>;
}
